export default __webpack_public_path__ + "static/media/bigbookshelf.b1f6812a.png";